import NotificationCenter from "../../../components/notifications/NotificationCenter";
import ui from "../../components/ui/ui.module.css";

// /me/notifications: the large notifications view as a page (shared with the HR view).
const MyNotificationsPage = () => (
  <div className={ui.page}>
    <div className={ui.pageHeader}>
      <div>
        <h4 className="page-title">Notifications</h4>
        <p className="page-subtitle">
          Everything sent to you: approvals, results and HR alerts.
        </p>
      </div>
    </div>
    <div className={ui.card}>
      <div className="p-3">
        <NotificationCenter />
      </div>
    </div>
  </div>
);

export default MyNotificationsPage;
